import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Menu, X, User, Facebook } from 'lucide-react';

const LOGO_URL = "/logo-andeni.png";
const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61590294917178";

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { href: '/', label: 'Acasă' },
    { href: '/servicii', label: 'Servicii' },
    { href: '/despre-noi', label: 'Despre noi' },
    { href: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link">
            <img 
              src={LOGO_URL} 
              alt="AnDeni Time Solutions" 
              className="h-14 md:h-16 w-auto drop-shadow-md"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                data-testid={`nav-${link.label.toLowerCase().replace(/\s/g, '-')}-link`}
                className={`text-sm font-medium transition-colors duration-200 ${
                  isActive(link.href)
                    ? 'text-blue-600'
                    : 'text-slate-600 hover:text-slate-900'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-4">
            <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-blue-600 transition-colors" title="Facebook" data-testid="nav-facebook-link">
              <Facebook className="h-5 w-5" />
            </a>
            <Link to="/cont" data-testid="nav-account-link">
              <Button variant="ghost" size="sm" className="gap-2">
                <User className="h-4 w-4" />
                Contul meu
              </Button>
            </Link>
            <Link to="/comanda" data-testid="nav-order-btn">
              <Button className="bg-blue-600 hover:bg-blue-700 text-white shadow-md active:scale-95 transition-all">
                Comandă serviciu
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="nav-mobile-menu-btn"
            aria-label={mobileMenuOpen ? 'Închide meniul' : 'Deschide meniul'}
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6 text-slate-900" />
            ) : (
              <Menu className="h-6 w-6 text-slate-900" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-100 mobile-menu-enter">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  data-testid={`nav-mobile-${link.label.toLowerCase().replace(/\s/g, '-')}-link`}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`text-base font-medium py-2 ${
                    isActive(link.href)
                      ? 'text-blue-600'
                      : 'text-slate-600'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <hr className="border-slate-100" />
              <Link
                to="/cont"
                onClick={() => setMobileMenuOpen(false)}
                data-testid="nav-mobile-account-link"
                className="text-base font-medium py-2 text-slate-600 flex items-center gap-2"
              >
                <User className="h-4 w-4" />
                Contul meu
              </Link>
              <Link to="/comanda" onClick={() => setMobileMenuOpen(false)} data-testid="nav-mobile-order-btn">
                <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white">
                  Comandă serviciu
                </Button>
              </Link>
              <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" onClick={() => setMobileMenuOpen(false)} className="text-base font-medium py-2 text-slate-600 flex items-center gap-2" data-testid="nav-mobile-facebook-link">
                <Facebook className="h-5 w-5 text-blue-600" />
                Facebook
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
